import React from "react";
import Dialog from "components/dialog";
import {
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    FacebookIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";
import styles from "./styles.css.js";
import withStyles from "../../../with-styles/with-styles";
import { DataGridItem } from "components/data-grid";

const ShareUrlDialog = ({classes, intl, handleClose, open, clip}) => {

    const quote = '';

    return (
        <Dialog
            title={intl.formatMessage({id: "recording.share"})}
            open={open}
            onClose={handleClose}
        >
            <div className={classes.socialGrid}>
                <DataGridItem small centered>
                    <div className={classes.socialBlock}>
                        <FacebookShareButton
                            url={clip.url}
                            quote={quote}>
                            <FacebookIcon round size={40}/>
                        </FacebookShareButton>
                        <div>Facebook</div>
                    </div>
                </DataGridItem>
                <DataGridItem small centered>
                    <div className={classes.socialBlock}>
                        <TwitterShareButton url={clip.url}
                                            quote={quote}>
                            <TwitterIcon round size={40}/>
                        </TwitterShareButton>
                        <div>Twitter</div>
                    </div>
                </DataGridItem>
                <DataGridItem small centered>
                    <div className={classes.socialBlock}>
                        <WhatsappShareButton url={clip.url}
                                             quote={quote}>
                            <WhatsappIcon round size={40}/>
                        </WhatsappShareButton>
                        <div>Whatsapp</div>
                    </div>
                </DataGridItem>
                <DataGridItem small centered>
                    <div className={classes.socialBlock}>
                        <TelegramShareButton url={clip.url}
                                             quote={quote}>
                            <TelegramIcon round size={40}/>
                        </TelegramShareButton>
                        <div>Telegram</div>
                    </div>
                </DataGridItem>
            </div>
        </Dialog>
    )
};

export default withStyles(styles)(ShareUrlDialog);